// ACTIVE BLUES
export const ACTIVE_PRIMARY = "#15749D";
export const ACTIVE_HOVER_PRIMARY = "#0d8dc4";
export const TEMP_GREY = "#f8f9fa";

export const HOVER_LIGHT_BLUE = "#EFFAFF";
export const HOVER_GREY = "#E5E7EC";

// ERROR
export const ERROR_PRIMARY = "#ed125f";
export const ERROR_SECONDARY = "#fff4f8";
export const ERROR_AMOUNT = "#D11053";

// SHADOWS
export const BOX_SHADOW = "#d1d1d1";

// TEXT
export const TEXT_PRIMARY = "#292A33";
export const BORDER_PRIMARY = "#caced8";
export const LABEL_PRIMARY = "#6e727e";
export const COLOR_SOLID = "#3b414d";

// MISC
export const WHITE = "#ffffff";
export const LOADING_GREY = "#f1f1f1";
export const MINESHAFT_GREY = "#292A33";
export const MODAL_BACKGROUND = "#f7f7f7";
export const BACKGROUND_DIM = "#f7f7f7";
export const BACKGROUND_DARK = "#3b414d";
export const BACKGROUND_GREY = "#F6F6F9";
export const BACKGROUND_LIGHT_GREEN = "#E8FFEF";
export const CITYVILLE_GREY = "#6D717E";
export const COOL_GREY = "#878E9B";

export const INACTIVE_GREY = "#caced8";

export const DISABLED_GREY_TEXT = "#6e727e";
export const AI_PRIMARY = "#2b2d72";
export const AI_PRIMARY_HOVER = "#1e1f5c";
export const AI_ACCENT = "#5c4ee5";
export const AI_ACCENT_LIGHT = "#eeefff";
export const SEARCH_BORDER = "#dfe1e6";
export const SEARCH_BORDER_HOVER = "#c1c7d0";
export const SEARCH_SURFACE_HOVER = "#f4f5f7";
export const SEARCH_PLACEHOLDER = "#9aa0ac";
export const SEARCH_DIVIDER = "#ebecf0";

// ALERTS
export const SUCCESS_GREEN = "#47b872";
export const SUCCESS_GREEN_LIGHT = "#d9ffe8";
export const WARNING_YELLOW = "#F4CB71";
export const WARNING_YELLOW_LIGHT = "#FDF4DA";
export const DANGER_RED = ERROR_PRIMARY;
export const DANGER_SECONDARY = ERROR_SECONDARY;
export const INFO_BLUE = "#689CDF";
export const INFO_BLUE_LIGHT = "#F3F8FC";

// Payments - Beta tab pill and announcement.
export const BETA_ORANGE = "#FF6E14";
export const BETA_ORANGE_TINT = "#FFE9DA";
